import { getDataSource } from './dataSource';
import { Patient, CreatePatientData } from '../types/patient';

interface PatientFilters {
  page?: number;
  limit?: number;
  search?: string;
  isActive?: boolean;
}

interface PatientListResponse {
  patients: Patient[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    pages: number;
  };
}

class PatientService {
  async getPatients(filters: PatientFilters = {}): Promise<PatientListResponse> {
    const response = await getDataSource().getPatients(filters);
    return {
      patients: response.data.patients,
      pagination: response.data.pagination
    };
  }

  async getPatient(id: string): Promise<Patient> {
    return await getDataSource().getPatient(id);
  }

  async createPatient(data: CreatePatientData): Promise<Patient> {
    return await getDataSource().createPatient(data);
  }

  async updatePatient(id: string, data: Partial<Patient>): Promise<Patient> {
    return await getDataSource().updatePatient(id, data);
  }

  async deletePatient(id: string): Promise<void> {
    return await getDataSource().deletePatient(id);
  }
}

export const patientService = new PatientService();
export type { PatientFilters, PatientListResponse };